export * from './bulk-backtest.component';
